"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var sub_menu_item_1 = require("./sub-menu-item");
var dom_helpers_1 = require("../util/dom-helpers");
var react_overlays_1 = require("../react-overlays");
var _1 = require("../util/_");
var MegaMenuPopover = /** @class */ (function (_super) {
    __extends(MegaMenuPopover, _super);
    function MegaMenuPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            positionLeft: 1200
        };
        _this._needsFlush = false;
        _this.updatePosition = function () {
            var target = document.getElementById(_this.props.targetId);
            if (!target) {
                return;
            }
            var popoverWidth = dom_helpers_1.width(ReactDOM.findDOMNode(_this));
            var containerAbsPos = dom_helpers_1.position(ReactDOM.findDOMNode(_this).parentNode, document.body);
            var windowWidth = dom_helpers_1.width(document.body);
            var navPos = dom_helpers_1.position(target, ReactDOM.findDOMNode(_this).parentNode);
            var maxLeft = windowWidth - popoverWidth - containerAbsPos.left;
            var positionLeft = navPos.left + navPos.width / 2 - 100;
            if (positionLeft > maxLeft) {
                positionLeft = maxLeft;
            }
            if (positionLeft < 0) {
                positionLeft = 0;
            }
            _this.setState({
                positionLeft: positionLeft
            });
        };
        _this.handleSubmenuClick = function (activeSubmenu) {
            var onSubmenuClick = _this.props.onSubmenuClick;
            if (onSubmenuClick) {
                onSubmenuClick(activeSubmenu);
            }
        };
        _this.handleItemClick = function (item) {
            var onItemClick = _this.props.onItemClick;
            if (onItemClick) {
                onItemClick(item);
            }
        };
        _this.handleOnRootClose = function () {
            var onRootClose = _this.props.onRootClose;
            if (onRootClose) {
                onRootClose();
            }
        };
        return _this;
    }
    MegaMenuPopover.prototype.componentDidMount = function () {
        this.updatePosition();
    };
    MegaMenuPopover.prototype.componentWillReceiveProps = function () {
        this._needsFlush = true;
    };
    MegaMenuPopover.prototype.componentDidUpdate = function () {
        if (this._needsFlush) {
            this._needsFlush = false;
            this.updatePosition();
        }
    };
    MegaMenuPopover.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, config = _b.config, activeSubmenu = _b.activeSubmenu;
        var rootClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('mega-menu-popover')] = true,
            _a);
        var customProps = _1.omit(this.props, Object.keys(MegaMenuPopover.propTypes));
        // flatten submenus
        var submenus = config.submenus.reduce(function (a, b) { return a.concat(b); }, []);
        var numColumns = Math.min(3, Math.ceil(activeSubmenu.items.length / 8));
        var columnSize = Math.ceil(activeSubmenu.items.length / numColumns);
        var submenuColumns = [];
        for (var column = 0; column < numColumns; column++) {
            submenuColumns.push(React.createElement("div", { key: column, className: vdl_prefix_1.vdlPrefix('mega-menu-popover__items') }, activeSubmenu.items
                .slice(column * columnSize, column * columnSize + columnSize)
                .map(function (item, index) {
                var onItemClick = function () { return _this.handleItemClick(item); };
                return (React.createElement("div", { key: index, className: vdl_prefix_1.vdlPrefix('mega-menu-popover__item') },
                    React.createElement("a", { onClick: onItemClick, className: vdl_prefix_1.vdlPrefix('mega-menu-popover__link') }, item.label)));
            })));
        }
        return (React.createElement(react_overlays_1.RootCloseWrapper, { onRootClose: this.props.onRootClose, noWrap: true },
            React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(this.props.className, rootClasses), style: {
                    left: this.state.positionLeft
                } }),
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('mega-menu-popover__container') },
                    React.createElement("ul", { className: vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu') }, submenus.map(function (submenu, index) {
                        var active = activeSubmenu === submenu;
                        return (React.createElement(sub_menu_item_1.SubMenuItem, { key: index, config: submenu, onClick: _this.handleSubmenuClick, active: active }));
                    })),
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('mega-menu-popover__items-container') }, submenuColumns)))));
    };
    MegaMenuPopover.propTypes = {
        config: PropTypes.object.isRequired,
        activeSubmenu: PropTypes.object.isRequired,
        onSubmenuClick: PropTypes.func.isRequired,
        onItemClick: PropTypes.func,
        targetId: PropTypes.string,
        onRootClose: PropTypes.func.isRequired,
        className: PropTypes.string
    };
    return MegaMenuPopover;
}(React.Component));
exports.MegaMenuPopover = MegaMenuPopover;
